"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var api_base_1 = __importDefault(require("./api_base"));
exports.default = {
    get: function (userId, franchisorId) {
        return api_base_1.default
            .get("users/" + userId + "/accessible_franchisors/" + franchisorId + "?include_nested[]=subsidiaries")
            .then(function (response) { return response.data.data[0]; });
    },
    getAll: function (userId) {
        return api_base_1.default.get("users/" + userId + "/accessible_franchisors").then(function (response) { return response.data.data; });
    }
};
//# sourceMappingURL=users_accessible_franchisors_api.js.map